import { useMemo } from 'react';
import { ICategory, TCategoriesTree, TServiceMap } from '@features/categories/typescript';
import { createServiceMap } from '@utils/categoriesData';
const useServiceMap = (categoriesTree: TCategoriesTree): TServiceMap => useMemo(() => {
  const serviceMapObject = {} as TServiceMap;
  const values: ICategory[] = Object.values(categoriesTree);
  if (!values) return serviceMapObject;
  values.forEach(category => {
    Object.assign(serviceMapObject, createServiceMap(category));
  });
  return serviceMapObject;
}, [categoriesTree]);
export default useServiceMap;